import {
    CheckCircleOutline,
    DoDisturbOn,
    Download,
    Edit,
    Visibility,
} from "@mui/icons-material";
import {
    Alert,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { useEffect, useState } from "react";
import {
    GetAllSolutions,
    SearchOnSolutions,
    solutionReset,
} from "../../Redux/Solutions/SolutionsSlice";
import { PopupModal } from "../../Components/Modal/Modals";
import ShowSolution from "./ShowSolution";
import { Container } from "@mui/system";
import CardInformation from "../../Layouts/CardInfo/CardInformation";

const AllSolution = () => {
    const { user_id, lead_id } = useParams();
    const dispatch = useDispatch();

    const { solutions, isLoading } = useSelector((state) => state.solutions);
    const Solutions = solutions?.data?.data || [];
    const SolutionPagination = solutions?.data || [];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        const callSearchAction = async () => {
            await dispatch(
                GetAllSolutions({
                    user_id: user_id,
                    lead_id: lead_id,
                    page: newPage + 1,
                })
            );

            if (user_id)
                await dispatch(
                    GetAllSolutions({
                        user_id: user_id,
                        lead_id: lead_id,
                        page: newPage + 1,
                    })
                );
            else await dispatch(GetAllSolutions({ page: newPage + 1 }));
            await dispatch(solutionReset());
        };
        callSearchAction();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
        const callSearchAction = async () => {
            if (user_id)
                await dispatch(
                    GetAllSolutions({
                        user_id: user_id,
                        lead_id: lead_id,
                        paginate: event.target.value,
                    })
                );
            else
                await dispatch(
                    GetAllSolutions({ paginate: event.target.value })
                );
            await dispatch(solutionReset());
        };
        callSearchAction();
    };

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    const handelDownloadPdfFile = (e, path) => {
        const link = document.createElement("a");

        link.download = `${path}`;
        link.href = path;
        link.click();
    };

    const getCreatedAt = (date) => 
    {
        let newDate = new Date(date);
        return newDate.getMonth() + 1 + "-" + newDate.getDate() + "-" + newDate.getFullYear();
    }

    useEffect(() => {
        const CallGetAllSolutionsMethod = async () => {
            if (user_id || lead_id) {
                await dispatch(
                    GetAllSolutions({ user_id: user_id, lead_id: lead_id })
                );
            } else {
                await dispatch(GetAllSolutions());
            }
            await dispatch(solutionReset());
        };
        CallGetAllSolutionsMethod();
    }, [dispatch, lead_id, user_id]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <>
                    {user_id && user_id > 0 && (
                        <Container>
                            <CardInformation
                                data={Solutions[0]?.user}
                                ContractsCost={0}
                                type="user"
                            />
                        </Container>
                    )}
                    {lead_id && lead_id > 0 && (
                        <Container>
                            <CardInformation
                                data={Solutions[0]?.lead}
                                ContractsCost={0}
                                type="lead"
                            />
                        </Container>
                    )}
                    <TableContainerStyled component={Paper}>
                        <Table aria-label="simple table">
                            <TableHeadStyled>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell> User Name </TableCell>
                                    <TableCell> Lead </TableCell>
                                    <TableCell> Lead Email </TableCell>
                                    <TableCell>Lead Phone</TableCell>
                                    <TableCell>Installation Type</TableCell>
                                    <TableCell>Estimated Cost</TableCell>
                                    <TableCell>Monthly Payment</TableCell>
                                    <TableCell>Number Of Panels</TableCell>
                                    <TableCell>Dealer Fee</TableCell>
                                    <TableCell>Dealer Fee Amount</TableCell>
                                    <TableCell align="center"> Create </TableCell>
                                    <TableCell align="center">
                                        ACTIONS
                                    </TableCell>
                                </TableRow>
                            </TableHeadStyled>

                            <TableBody>
                                {Solutions.map((key, index) => (
                                    <TableRowStyled key={Math.random()}>
                                        <TableCellStyle>
                                            {rowsPerPage * page + index + 1}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            <Link
                                                to={`/dashboard/solutions/user=${key?.user?.id}`}
                                            >
                                                <Typography color="primary">
                                                    {key?.user.name}
                                                </Typography>
                                            </Link>
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            <Link
                                                to={`/dashboard/solutions/lead=${key?.lead?.id}`}
                                            >
                                                <Typography color="primary">
                                                    {key?.lead?.first_name +
                                                        " " +
                                                        key?.lead?.last_name}
                                                </Typography>
                                            </Link>
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key?.lead?.email}
                                        </TableCellStyle>
                                        {/* <TableCellStyle>{key.address}</TableCellStyle> */}
                                        <TableCellStyle>
                                            {key?.lead?.phone}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key.installation_type}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key.estimated_cost}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {Math.round(key.monthlyPayment)}
                                        </TableCellStyle>
                                        <TableCellStyle align="center">
                                            {key.number_of_panels}
                                        </TableCellStyle>

                                        <TableCellStyle align="center">
                                            {key.dealer_fee}
                                        </TableCellStyle>
                                        <TableCellStyle align="center">
                                            {key.dealer_fee_amount}
                                        </TableCellStyle>

                                        <TableCellStyle align="center">
                                            {getCreatedAt(key.created_at)}
                                        </TableCellStyle>
                                        <TableCellStyle align="center">
                                            {key.pdf_path && (
                                                <IconButton
                                                    onClick={(e) =>
                                                        handelDownloadPdfFile(
                                                            e,
                                                            key?.pdf_path
                                                        )
                                                    }
                                                    sx={{ color: "green" }}
                                                >
                                                    <Download />
                                                </IconButton>
                                            )}
                                            <IconButton>
                                                <Link
                                                    to={`/dashboard/solutions/show=${key.id}`}
                                                >
                                                    <Visibility color="primary" />
                                                </Link>
                                            </IconButton>
                                        </TableCellStyle>
                                    </TableRowStyled>
                                ))}
                            </TableBody>
                            <TableHeadStyled>
                                <TableRow>
                                    {SolutionPagination.total >= 20 && (
                                        <TablePagination
                                            rowsPerPageOptions={[
                                                20,
                                                50,
                                                100,
                                                { label: "All", value: -1 },
                                            ]}
                                            colSpan={12}
                                            count={SolutionPagination.total}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={
                                                handleChangeRowsPerPage
                                            }
                                        />
                                    )}
                                </TableRow>
                            </TableHeadStyled>
                        </Table>

                        {SolutionPagination.total < 1 && (
                            <Alert icon={false} severity="error">
                                <Typography
                                    variant="h6"
                                    className="MuiTypography-alignCenter"
                                >
                                    There are no items, please try again
                                </Typography>
                            </Alert>
                        )}
                    </TableContainerStyled>
                </>
            )}
        </>
    );
};

export default AllSolution;
